import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../components/common/PageHeader';
import { KdsStation } from '../components/common/KdsStation';
import { RefreshCw } from 'lucide-react';

export default function BarPage() {
  const { t } = useTranslation();
  return (
    <div className="p-4 md:p-6">
      <PageHeader title={t('kds.barTitle')} subtitle={t('kds.barSubtitle')}>
        <span className="flex items-center gap-1.5 text-sm text-muted-foreground"><RefreshCw className="h-4 w-4 animate-spin" style={{ animationDuration: '3s' }} /> {t('kds.autoUpdate')}</span>
      </PageHeader>
      <KdsStation station="bar" />
    </div>
  );
}
